import * as tslib_1 from "tslib";
import getFilterableMailListContextMenuItems from './getFilterableMailListContextMenuItems';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ContextualMenu, } from 'office-ui-fabric-react/lib/components/ContextualMenu';
var MailListItemContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemContextMenu, _super);
    function MailListItemContextMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailListItemContextMenu.prototype.render = function () {
        var anchorPoint = this.props.anchorPoint;
        // filter the menu items based on the should show behavior
        var validItems = getFilterableMailListContextMenuItems(this.props.rowKeys, this.props.tableViewId, this.props.onDismiss).filter(function (item) { return item.shouldShow(); });
        return (React.createElement(ContextualMenu, { shouldFocusOnMount: true, targetPoint: anchorPoint, useTargetPoint: true, directionalHint: 4 /* bottomLeftEdge */, onDismiss: this.props.onDismiss, items: validItems, calloutProps: { preventDismissOnScroll: true } }));
    };
    MailListItemContextMenu = tslib_1.__decorate([
        observer
    ], MailListItemContextMenu);
    return MailListItemContextMenu;
}(React.Component));
export default MailListItemContextMenu;
//# sourceMappingURL=MailListItemContextMenu.js.map